module.exports = __webpack_public_path__ + "img/oanda_loader.1a0e3ddf.gif";